module.exports = __webpack_public_path__ + "static/media/partner01.1f6de9f0.svg";